import { PeerTypes } from '@givebacks/api/store';
import { Combobox } from 'ui';

import { CreditValue } from './PeerSelect.types';
import { createWriteInOption } from './utils';

const WriteInOption = ({
  search,
  onChange,
  closeDropdown,
}: {
  search: string;
  onChange: (value: CreditValue) => void;
  closeDropdown?: () => void;
}) => {
  return (
    <Combobox.Option
      value={search}
      key={search}
      onClick={() => {
        onChange(createWriteInOption(search));
        closeDropdown?.();
      }}
    >
      + Write in - {search}
    </Combobox.Option>
  );
};

const NoSearchResult = ({
  type,
  search,
  onChange,
  closeDropdown,
  isLoading,
}: {
  type: PeerTypes;
  search: string;
  onChange: (value: CreditValue) => void;
  closeDropdown?: () => void;
  isLoading: boolean;
}) => {
  // Always show write-in for participants when search length > 2
  if (type === 'participants' && search.length > 2) {
    return <WriteInOption search={search} onChange={onChange} closeDropdown={closeDropdown} />;
  }

  // If loading, show searching state
  if (isLoading) {
    return <Combobox.Empty>Searching…</Combobox.Empty>;
  }

  return <Combobox.Empty>Nothing Found</Combobox.Empty>;
};

export { NoSearchResult };
